import { BallLogo } from './BallLogo'
import { LangToggle } from './LangToggle'
import { useI18n } from '../lib/i18n'
import type { Theme } from '../lib/theme'

interface Props {
  theme: Theme
  onToggleTheme: () => void
}

export function Header({ theme, onToggleTheme }: Props) {
  const { t } = useI18n()

  return (
    <header className="mb-4 flex items-center justify-between gap-3">
      <div className="flex items-center gap-2.5">
        <BallLogo />
        <div>
          <h1 className="text-[15px] leading-tight font-semibold tracking-tight sm:text-lg">
            Padel Madeira
          </h1>
          <p className="text-[11px] leading-tight sm:text-xs" style={{ color: 'var(--text-muted)' }}>
            {t.tagline}
          </p>
        </div>
      </div>

      <div className="flex items-center gap-2">
        <LangToggle />
        <button
          type="button"
          onClick={onToggleTheme}
          aria-label={theme === 'dark' ? t.themeToLight : t.themeToDark}
          className="grid size-9 place-items-center rounded-full border transition-colors"
          style={{ borderColor: 'var(--border)', color: 'var(--text-muted)' }}
        >
          {theme === 'dark' ? '☀' : '☾'}
        </button>
      </div>
    </header>
  )
}
